export const ASSETS = {
  heroVideo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_b312cf1f-53a0-48e7-9714-558bc9dfee99/artifacts/g0rt4frm_official-banner-video.mp4",
  portrait: "https://customer-assets-lxgj4vgw.emergentagent.net/job_b312cf1f-53a0-48e7-9714-558bc9dfee99/artifacts/92tj88ox_820BA664-87DA-4E94-9C3E-CC5DBB92A8A4.JPG",
  logo: "/casey-logo.png",
  heroFallback: "https://caseymuze.com/wp-content/uploads/2024/07/cropped-Avenue-Speak-Branding-Casey-Kyrsten-Ashlay-Photography-20-Edit-scaled-1.jpg",
  drummer: "https://caseymuze.com/wp-content/uploads/2025/07/cropped-53171610614_2665eac4b3_c-1.jpg",
  speaker: "https://caseymuze.com/wp-content/uploads/2025/07/cropped-IMG_7463-2Tyler-Loop-Season-8.jpg",
  author: "https://caseymuze.com/wp-content/uploads/2025/07/cropped-cropped-305ECD6D-004C-4A47-BF5F-6280CB450854.jpeg",
  headshot: "https://caseymuze.com/wp-content/uploads/2025/07/casey-headshot.jpeg",
  brain: "https://customer-assets-jt897jd0.emergentagent.net/job_trauma-healing-tech/artifacts/y41veztq_4215261.png",
};

export const SCHEDULER_URL = "https://bracednomore.info/scheduler/cunsultation-call";
export const MAIN_SITE = "https://bracednomore.info/";
export const EMAIL = "cmuze@avenuespeak.info";
export const SOCIALS = [
  { label: "Instagram", href: "https://instagram.com" },
  { label: "LinkedIn", href: "https://linkedin.com" },
  { label: "Google", href: "https://www.google.com/maps/place/Casey+Muze+%22the+royal+speaker%22/@31.1689103,-100.0768425,2000663m/data=!4m6!3m5!1s0x3cefd56a28c744f:0xfd011a0ebec92434!8m2!3d31.1689103!4d-100.0768425!16s%2Fg%2F11rdcjmls2" },
];
